module.exports = __webpack_public_path__ + "public/images/hexagon-circle.577bed2eee68285f1fd0a1d119c4005c.webp";